var followBtns = function () {
	var $el = {};
	var className = {};
	var timeBubbleAdd = 0;
	var timeBubbleRemove = 0;
	var delay = 2000;
	var unallowedPaths = [
		'poradna',
		'poradna\\/[\\w-]+',
		'objednat-se',
		'darkovy-poukaz',
		'tematicke-poradny',
		'tematicke-poradny\\/[\\w-]+',
		'en\\/poradna',
		'en\\/poradna\\/[\\w-]+',
	];

	var addStart = function () {
		setTimeout(function () {
			$el.root.addClass(className.start);
		}, delay);
	};

	var bubbleAdd = function () {
		$el.root.addClass(className.bubble);
	};

	var bubbleRemove = function () {
		$el.root.removeClass(className.bubble);
	};

	var bubblesTimeRemove = function () {
		clearInterval(timeBubbleAdd);
		clearInterval(timeBubbleRemove);
	};

	var setTimeBubble = function () {
		timeBubbleAdd = setTimeout(bubbleAdd, delay + 2000);
		timeBubbleRemove = setTimeout(bubbleRemove, delay + 2000 + 5000);

		$el.plus.hover(function () {
			bubblesTimeRemove();
			bubbleAdd();
		}, function () {
			bubbleRemove();
		});
	};

	var detalClassAdd = function () {
		$el.root.addClass(className.detail);
	};

	var detalClassRemove = function () {
		$el.root.removeClass(className.detail);
	};

	var detailOpen = function () {
		bubblesTimeRemove();
		bubbleRemove();
		detalClassAdd();
	};

	var detailClose = function () {
		detalClassRemove();
	};

	var adWatcher = function () {
		var maxTime = 10000;
		var time = 0;
		var interval = setInterval(function () {
			if($('#pfm-wrapper').is(':visible')) {
				adAdapter.active.mobileBottom();
				clearInterval(interval);
			} else {
				if (time > maxTime) {
					clearInterval(interval);
					return;
				}
				time += 100;
			}
		}, 200);
	};

	var isActivable = function() {
		var pattern = '^\\/(' + unallowedPaths.join('|') + ')$'
		var regExp = new RegExp(pattern);
		var pathname = window.location.pathname;

		return (pathname.match(regExp) === null);
	}

	var init = function () {
		if (isActivable()) {
			adWatcher();
			$el = {
				root: $('.js-followBtns'),
				plus: $('.js-followBtns-plus'),
				close: $('.js-followBtns-close'),
			};

			className = {
				start: 'is-start',
				bubble: 'is-bubble',
				detail: 'is-detail'
			};

			addStart();
			setTimeBubble();
			$el.plus.click(detailOpen);
			$el.close.click(detailClose);
		}
	};

	return {
		init: init
	};
}();

UL.register(followBtns);
